<template>
    <div class="select-plan-view">
        <div v-if="!paymentsEnabled" class="sp-iphone">
            <div class="sp-iphone-logo">
                <v-img :src="imgPlaceholder" width="200" />
            </div>
            <div class="sp-iphone-card">
                <v-icon size="20" color="accent">mdi-information-outline</v-icon>
                <div class="sp-iphone-text">
                    <div>{{ $t('payment.account_without_plan') }}</div>
                    <div>{{ $t('payment.account_without_plan_redirect') }}</div>
                </div>
            </div>
        </div>

        <select-plan v-else with-coupon @change="plan = $event" @plan="showConfirm" @coupon="couponId = $event" />

        <div class="sp-logout">
            <logout-button small outlined />
        </div>

        <kimsa-confirm ref="confirmModal" :title="$t('common.notice')" :content="confirmMessage" :loading="loading"
            :persistent="false" @confirm="save" :close-on-confirm="false" />
    </div>
</template>

<script>

import SelectPlan from '@/components/coach/SelectPlan'
import KimsaConfirm from "@/components/common/KimsaConfirm";
import { mapActions } from "vuex";
import LogoutButton from "@/components/common/inputs/LogoutButton";
import { subscribeCoachPlan } from "@/utils/Plans";

export default {
    components: {
        LogoutButton,
        KimsaConfirm,
        SelectPlan,
    },
    data() {
        return {
            plan: null,
            loading: false,
            confirmMessage: '',
            couponId: null,
        }
    },
    computed: {
        paymentMethodId(vm = this) {
            return vm.account?.stripeAccount?.paymentMethod?.id || null
        },
    },
    methods: {
        ...mapActions(['bindUserAccount']),
        showConfirm() {
            const vm = this
            if (!vm.plan?.isFree && !vm.paymentMethodId)
                return vm.toast(vm.$t('payment.no_has_credit_card'), 'error')

            vm.confirmMessage = vm.$t('coach.confirm_plan')
            const hasTrialDays = vm.account?.stripeAccount?.trialEnded === false || false
            if (hasTrialDays) vm.confirmMessage = `<b>${vm.$t('coach.yet_free_days')}</b> ${vm.confirmMessage}`
            vm.$refs.confirmModal.show()
        },
        async save() {
            const vm = this
            await vm.withLoading(async () => {
                const { status, messageKey, detail } = await subscribeCoachPlan({ plan: vm.plan, couponId: vm.couponId })
                vm.$refs.confirmModal?.hide()

                if (status === 'coupon-error') return vm.toast(vm.$t(messageKey), 'error')

                if (status === 'card-error') {
                    vm.toast(vm.$t(messageKey), 'error')
                    return vm.pushRoute({ name: `${vm.accountType}.credit-card`, query: { deleted: 'true' } })
                }

                if (status === 'error') {
                    return vm.toast(`${vm.$t(messageKey)}${detail ? `: ${detail}` : ''}`, 'error')
                }

                await vm.bindUserAccount(vm.currentUser)
                await vm.pushRoute({ name: `${vm.accountType}.home` })
            })
        },
    },
}
</script>

<style scoped>

.select-plan-view {
    padding: 16px 0 24px;
}

.sp-iphone {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 20px;
}

.sp-iphone-logo {
    padding: 12px;
    border-radius: 12px;
    border: 1px solid var(--v-outline-base);
    background: var(--v-surface2-base);
}

.sp-iphone-card {
    display: flex;
    align-items: flex-start;
    gap: 12px;
    max-width: 520px;
    padding: 16px;
    border-radius: 12px;
    border: 1px solid var(--v-outline-base);
    background: var(--v-surface-base);
}

.sp-iphone-text {
    font-size: var(--fs-body);
    color: var(--v-txtSecondary-base);
    line-height: 1.5;
}

.sp-logout {
    margin-top: 32px;
    text-align: center;
}

</style>
